module.exports = __webpack_public_path__ + "static/media/life-ring.0372f3e4.svg";